import { type PieSectorShapeProps, Sector as ReSector } from 'recharts';

import { type Sector } from '@/components/common/charts/PieChart';
import { getColorCssValue, getColorCssValueWithAlpha } from '@/utils/theme';

export const PieSector = (props: PieSectorShapeProps) => {
  const { payload } = props;

  const sector: Sector = payload;

  return (
    <ReSector {...props} fill={getColorCssValueWithAlpha(sector.color, 0.26)} stroke={getColorCssValue(sector.color)} />
  );
};
